function CustomDeviceSmallest() {
    const device_widith = window.screen.availWidth;
    return device_widith <= 350;
  }
  
  export default CustomDeviceSmallest;
  